export default __webpack_public_path__ + "resources/icons/d141-dca3.png";